import { css, List, styled } from '@mui/material';

export const TooltipList = styled(List)(
  () => css`
    list-style-type: disc;
    list-style-position: inside;
  `,
);
